<template>
  <div>
    <rest-form-item :label="$t('ChannelConfig_EngageHub_URL')" prop="url">
      <el-input
        v-model="model.params.url"
        :placeholder="$t('ChannelConfig_EngageHub_URL_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_EngageHub_Password')"
      prop="password"
    >
      <el-input
        v-model="model.params.password"
        type="password"
        :placeholder="$t('ChannelConfig_EngageHub_Password_Placeholder')"
      />
    </rest-form-item>
    <rest-form-item
      :label="$t('ChannelConfig_EngageHub_ServiceID')"
      prop="service_id"
    >
      <el-input
        v-model="model.params.service_id"
        :placeholder="$t('ChannelConfig_EngageHub_ServiceID_Placeholder')"
      />
    </rest-form-item>
  </div>
</template>

<script>
import RestFormItem from '@/common/components/rest/RestFormItem'

export default {
  components: { RestFormItem },
  props: {
    model: {
      type: Object,
      required: true
    }
  },
  created() {
    if (!this.$route.query.id) {
      this.$set(this.model, 'type', 'sms')
      this.$set(this.model, 'channel', 'engage_hub')
      this.$set(this.model, 'params', {
        url: '',
        password: '',
        service_id: ''
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/modules/channels/providers/EngageHub.vue